import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { POPUP_MENU_EVENTS } from '@/values/general.values';

@Component({
  name: 'ed-popup-menu'
})
class EdPopupComponent extends Vue {

  @Prop() buttonCss: string;
  @Prop() nudgeBottom: number;
  @Prop() closeOnContentClick: boolean;
  @Prop({ default: false }) top: boolean;
  @Prop({ default: false }) attach: boolean;

  get closeOnContentClickValue() {
    if(this.closeOnContentClick === false) {
      return this.closeOnContentClick
    } else {
      return true;
    }
  }

  closeMenu() {
    (this.$refs.menu as Vue & { forceClose: () => boolean }).forceClose();
  }

  created() {
    this.$edEventBus.$on(POPUP_MENU_EVENTS.CLOSE_POPUP_MENU,  this.closeMenu)
  }

  destroyed() {
    this.$edEventBus.$off(POPUP_MENU_EVENTS.CLOSE_POPUP_MENU,  this.closeMenu)
  }

}

export default Vue.component('ed-popup-menu', EdPopupComponent);